// export const SET_BUSDATA = 'SET_BUSDATA';

const actionTypes={
     SET_BUSDATA : 'SET_BUSDATA',
     SET_BUSDATA_ERROR: 'SET_BUSDATA_ERROR',
     SET_FROM_TO:'SET_FROM_TO',
     SET_USER_DETAILS:'SET_USER_DETAILS'
}

export default actionTypes